import { FC, useEffect, useRef, useState } from "react";
import Chevron from "../../UI/Icons/Chevron";
import PendingCandidates from "./PendingCandidates";
import { getAllCandidatesThunk } from "../../../store/superadmin/thunks";
import {
  useAppDispatch as useDispatch,
  useAppSelector as useSelector,
} from "../../../store";
import {
  hideTransparentPreloaderAction,
  showTransparentPreloaderAction,
} from "../../../store/application/slice";
import AllCandidates from "./AllCandidates";
import {
  CANDIDATE_SORT_OPTIONS,
  COMPLIANCE_ALERTS_SORT_OPTIONS,
  DEFAULT_ITEMS_PER_PAGE,
  DEFAULT_SEARCH_INPUT_DEBOUNCE_DELAY,
  DEFAULT_SEARCH_INPUT_LENGTH,
  EMPLOYEE_PENDING_REVIEW_SORT_OPTIONS,
} from "../../../constants/app";
import TextInput from "../../UI/Inputs/TextInput";
import SortBySelect from "../../UI/Inputs/SortBySelect";
import useDebouncedValue from "../../../hooks/useDebouncedValue";
import { EARLY_CHILDHOOD_EDUCATION } from "../../../models/Onboarding/onboarding-values";
import { resetReferooDocumentsAction } from "../../../store/superadmin/slice";

const AdminCentres: FC = () => {
  const dispatch = useDispatch();
  const isApiLoaded = useRef(false);

  const allCandidatesList = useSelector(
    (state) => state.superadmin.allCandidates
  );
  const isShowNotification = useSelector((state) => state.app.isShowNotification)

  const [isOpen1, setisOpen1] = useState(true);
  const [isOpen2, setisOpen2] = useState(true);
  const [isComplainceAlertsOpen, setIsComplainceAlertsOpen] = useState(true);
  const [selectedKeyword, setSelectedKeyword] = useState<string>("");
  const [searchInput, setSearchInput] = useState("");
  const [currentPendingPage, setCurrentPendingPage] = useState<number>(1);
  const [currentApprovedPage, setCurrentApprovedPage] = useState<number>(1);
  const [currentComplianceAlertPage, setCurrentComplianceAlertPage] = useState<number>(1);
  const [pendingPerPage, setPendingPerPage] = useState<number>(
    DEFAULT_ITEMS_PER_PAGE
  );
  const [approvedPerPage, setApprovedPerPage] = useState<number>(
    DEFAULT_ITEMS_PER_PAGE
  );
  const [complianceAlertsPerPage, setComplianceAlertsPerPage] = useState<number>(
    DEFAULT_ITEMS_PER_PAGE
  );
  // const [sortOrder, setSortOrder] = useState<string>("asc");
  const [selectedSort, setSelectedSort] = useState<string>("first_name-asc");
  const [selectedSortBy, setSelectedSortBy] = useState<string>("first_name");
  const [selectedSortOrder, setSelectedSortOrder] = useState<string>("asc");
  const [itemPerPageList, setItemPerPageList] = useState<number>(
    DEFAULT_ITEMS_PER_PAGE
  );
  const [selectedPendingReviewSort, setSelectedPendingReviewSort] = useState<string>("created_at-desc");
  const [selectedPendingReviewSortBy, setSelectedPendingReviewSortBy] = useState<string>("created_at");
  const [selectedPendingReviewSortOrder, setSelectedPendingReviewSortOrder] = useState<string>("desc");
  
  const [selectedComplianceAlertsSort, setSelectedComplianceAlertsSort] = useState<string>("date_renewal-asc");
  const [selectedComplianceAlertsSortBy, setSelectedComplianceAlertsSortBy] = useState<string>("date_renewal");
  const [selectedComplianceAlertsSortOrder, setSelectedComplianceAlertsSortOrder] = useState<string>("asc");

  const pendingCandidateCount = allCandidatesList?.pending_reviews_total ?? 0;
  const complianceAlertsCount = allCandidatesList?.compliance_alerts_total ?? 0;
  const approvedCandidateCount = allCandidatesList?.candidates_total ?? 0;
  const totalCandidatesCount = approvedCandidateCount;

  /**
   * Fetches all candidates based on the current page and items per page.
   * It dispatches the `getAllCandidatesThunk` action to get the candidates data.
   */
  const getAllCandidates = async () => {
    dispatch(resetReferooDocumentsAction()); // Reset referoo documents on error
    dispatch(showTransparentPreloaderAction());
    await dispatch(
      getAllCandidatesThunk({
        keyword: selectedKeyword,
        pending_page: currentPendingPage,
        approved_page: currentApprovedPage,
        compliance_alerts_page: currentComplianceAlertPage,
        pending_per_page: pendingPerPage,
        approved_per_page: approvedPerPage,
        compliance_alerts_per_page: complianceAlertsPerPage,
        pending_emp_sort_by: selectedPendingReviewSortBy,
        pending_emp_sort_order: selectedPendingReviewSortOrder,
        sort_by: selectedSortBy,
        sort_order: selectedSortOrder,
        compliance_alerts_sort_by: selectedComplianceAlertsSortBy,
        compliance_alerts_sort_order: selectedComplianceAlertsSortOrder,
      })
    );
    dispatch(hideTransparentPreloaderAction());
  };

  const handleSelectFilter = (selectedOption: any) => {};

  const handleSorting = (selectedOption: any) => {
    let splitValue = selectedOption?.value?.split("-");
    setSelectedSort(selectedOption?.value);
    setSelectedSortBy(splitValue[0]);
    setSelectedSortOrder(splitValue[1]);
  };

  const handlePendingReviewSelectFilter = (selectedOption: any) => {};

  const handlePendingReviewSorting = (selectedOption: any) => {
    setCurrentPendingPage(1);
    let splitValue = selectedOption?.value?.split("-");
    setSelectedPendingReviewSort(selectedOption?.value);
    setSelectedPendingReviewSortBy(splitValue[0]);
    setSelectedPendingReviewSortOrder(splitValue[1]);
  };

  const handleComplianceAlertsSelectFilter = (selectedOption: any) => {};

  const handleComplianceAlertsSorting = (selectedOption: any) => {
    setCurrentComplianceAlertPage(1);
    let splitValue = selectedOption?.value?.split("-");
    setSelectedComplianceAlertsSort(selectedOption?.value);
    setSelectedComplianceAlertsSortBy(splitValue[0]);
    setSelectedComplianceAlertsSortOrder(splitValue[1]);
  };

  /**
   * Fetches all candidates when the component mounts or when the `selectedKeyword`, `currentPendingPage`, `currentApprovedPage`, or `itemPerPageList` changes.
   */

  /**
   * Handles the change in the number of items per page by updating the `itemPerPageList` state.
   */
  useEffect(() => {
    if (isApiLoaded.current) {
      // Skip the first render
      isApiLoaded.current = false;
      return;
    }
    if(!isShowNotification) {
      getAllCandidates();
    }
  }, [
    selectedKeyword,
    currentPendingPage,
    currentApprovedPage,
    currentComplianceAlertPage,
    pendingPerPage,
    approvedPerPage,
    complianceAlertsPerPage,
    selectedPendingReviewSortBy,
    selectedPendingReviewSortOrder,
    selectedSortBy,
    selectedSortOrder,
    selectedComplianceAlertsSortBy,
    selectedComplianceAlertsSortOrder,
    isShowNotification
  ]);

  /**
   * Debounces the `selectedKeyword` state to avoid excessive API calls while the user is typing.
   * The debounced value is used to trigger the API call for fetching candidates.
   */
  const debouncedSearch = useDebouncedValue(
    searchInput,
    DEFAULT_SEARCH_INPUT_DEBOUNCE_DELAY
  );

  /**
   * Handles the change in the search input by updating the `selectedKeyword` state.
   * It also resets the current page to 1 if the search input is empty or exceeds the default length.
   *
   */
  useEffect(() => {
    if (
      debouncedSearch.length === 0 ||
      debouncedSearch.length > DEFAULT_SEARCH_INPUT_LENGTH
    ) {
      setSelectedKeyword(debouncedSearch); // Update the selected keyword state
      setCurrentApprovedPage(1); // Reset the current page to 1
      setCurrentPendingPage(1); // Reset the current page to 1
      setCurrentComplianceAlertPage(1); // Reset the current page to 1
    }
  }, [debouncedSearch]);

  /**
   * Conver the ISO date string to a readable format DD-MM-YYY.
   * @param isoDateString - The ISO date string to format.
   * @returns
   */
  const formatDateToReadable = (isoDateString: string): string => {
    const date = new Date(isoDateString);
    const options: Intl.DateTimeFormatOptions = {
      weekday: "short",
      day: "2-digit",
      month: "short",
      year: "numeric",
    };
    return new Intl.DateTimeFormat("en-GB", options).format(date);
  };

  const getCandidateQualification = (
    qualification: string,
    alternamePosition?: string
  ): string => {
    let alternamePositionText = "";
    if (alternamePosition) {
      let alternatePositionList: string[] = [];
      try {
        alternatePositionList = JSON.parse(alternamePosition);
      } catch (e) {
        alternatePositionList = [];
      }
      if (alternatePositionList.length > 0) {
        const filtered = alternatePositionList
          .filter((item: string) => !["1", "2", "5"].includes(item))
          .join(", ");
        alternamePositionText = filtered || "";
      }
    }
    if (qualification === "post_graduate_diploma") {
      return (
        String(EARLY_CHILDHOOD_EDUCATION.POST_GRADUATE_DIPLOMA) +
        (alternamePositionText ? ", " + alternamePositionText : "")
      );
    } else if (qualification === "bachelor_or_degree") {
      return (
        String(EARLY_CHILDHOOD_EDUCATION.BACHELOR_OR_DEGREE) +
        (alternamePositionText ? ", " + alternamePositionText : "")
      );
    } else if (qualification === "diploma") {
      return (
        String(EARLY_CHILDHOOD_EDUCATION.DIPLOMA) +
        (alternamePositionText ? ", " + alternamePositionText : "")
      );
    } else if (qualification === "certificate_iii") {
      return (
        String(EARLY_CHILDHOOD_EDUCATION.CERTIFICATE_III) +
        (alternamePositionText ? ", " + alternamePositionText : "")
      );
    } else if (qualification === "currently_studying") {
      return (
        String(EARLY_CHILDHOOD_EDUCATION.I_AM_CURRENTLY_STUDYING) +
        (alternamePositionText ? ", " + alternamePositionText : "")
      );
    } else if (qualification === "no_qualifications") {
      return (
        String(EARLY_CHILDHOOD_EDUCATION.I_HAVE_NO_QUALIFICATION) +
        (alternamePositionText ? ", " + alternamePositionText : "")
      );
    } else {
      return alternamePositionText ? alternamePositionText : "";
    }
  };

  return (
    <>
      {/* Figma 3.0 Candidate Management */}
      <div className="d-flex flex-column gap-20">
        <div className="d-flex flex-column">
          <div className="d-flex gap-10 justify-content-between">
            <div className="d-flex gap-5 align-items-center top-radius-10px fs-22 fs-mobile-16 fw-400 px-15px py-5px bg-black text-white">
              <span className="fw-700">{totalCandidatesCount}</span> Employees
            </div>
            {/* <button type="button" className="btn-theme bg-white text-black">
              <RoundedPlus width={24} height={24} fill="black" />
              Create a Employee
            </button> */}
          </div>
          <div className="bg-black w-100 h-5px"></div>
        </div>
        <div className="d-flex gap-10 align-items-center">
          <div className="form-group w-200px mobile-w-100 input-icon icon-left">
            <TextInput
              placeholder="Search..."
              field="search"
              onChange={(e) => setSearchInput(e.target.value)}
              showSearchIcon={true}
              floatingLabel={false}
            />
          </div>
        </div>
        <div className="d-flex flex-column gap-10">
          <div className="position-relative bg-alert-light py-8px px-15px radius-8px d-flex flex-column flex-lg-row gap-8 align-items-center justify-content-between">
            <div
              className="d-flex gap-8 align-items-center cursor-pointer"
              onClick={() => setisOpen1(!isOpen1)}
            >
              <Chevron isOpen={isOpen1} />
              <div className="fs-16 fw-700 text-black">
                {pendingCandidateCount} Pending
                {pendingCandidateCount > 1 ? "s" : ""}
              </div>
            </div>
            <div className="d-flex gap-3 align-items-center">
              <div className="fs-13 text-black text-nowrap">Sort By</div>
              <SortBySelect
                options={EMPLOYEE_PENDING_REVIEW_SORT_OPTIONS}
                placeholder="Select..."
                enableFilter={false}
                defaultValue={EMPLOYEE_PENDING_REVIEW_SORT_OPTIONS[4]}
                onChange={handlePendingReviewSorting}
                onSelect={handlePendingReviewSelectFilter}
              />
            </div>
          </div>
          {isOpen1 && (
            <>
              {allCandidatesList && (
                <PendingCandidates
                  setPendingPerPage={setPendingPerPage}
                  formatDateToReadable={formatDateToReadable}
                  candidatesList={allCandidatesList}
                  setItemPerPageList={setItemPerPageList}
                  setCurrentPendingPage={setCurrentPendingPage}
                  currentPendingPage={currentPendingPage}
                  getAllCandidates={getAllCandidates}
                  getCandidateQualification={getCandidateQualification}
                />
              )}
            </>
          )}
        </div>
        <div className="d-flex flex-column gap-10">
          <div className={`position-relative ${complianceAlertsCount > 0 ? "bg-alert-light" : "bg-off-white"} py-8px px-15px radius-8px d-flex flex-column flex-lg-row gap-8 align-items-center justify-content-between`}>
            <div
              className="d-flex gap-8 algin-items-center cursor-pointer"
              onClick={() => setIsComplainceAlertsOpen(!isComplainceAlertsOpen)}
            >
              {complianceAlertsCount > 0 && <Chevron isOpen={isComplainceAlertsOpen} />}
              <div className="fs-16 fw-700 text-black">
                {complianceAlertsCount ?? 0} Compliance Alert
                {(complianceAlertsCount ?? 0) > 1 ? "s" : ""}
              </div>
            </div>
            <div className="d-flex gap-3 align-items-center">
              <div className="fs-13 text-black text-nowrap">Sort By</div>
              <SortBySelect
                options={COMPLIANCE_ALERTS_SORT_OPTIONS}
                placeholder="Select..."
                enableFilter={false}
                defaultValue={COMPLIANCE_ALERTS_SORT_OPTIONS[2]}
                onChange={handleComplianceAlertsSorting}
                onSelect={handleComplianceAlertsSelectFilter}
              />
            </div>
          </div>
          {isComplainceAlertsOpen && (allCandidatesList && allCandidatesList?.compliance_alerts_total > 0) && (
            <AllCandidates
              type="compliance_alerts"
              setSortOrder={setSelectedSort}
              setApprovedPerPage={setComplianceAlertsPerPage}
              candidatesList={allCandidatesList.compliance_alerts}
              currentApprovedPage={currentComplianceAlertPage}
              setCurrentApprovedPage={setCurrentComplianceAlertPage}
              getAllCandidates={getAllCandidates}
              getCandidateQualification={getCandidateQualification}
              totalList={allCandidatesList.compliance_alerts_total}
            />
          )}
        </div>
        <div className="d-flex flex-column gap-10">
          <div className="position-relative bg-teal-light py-8px px-15px radius-8px d-flex flex-column flex-lg-row gap-8 align-items-center justify-content-between">
            <div
              className="d-flex gap-8 algin-items-center cursor-pointer"
              onClick={() => setisOpen2(!isOpen2)}
            >
              <Chevron isOpen={isOpen2} />
              <div className="fs-16 fw-700 text-black">
                {approvedCandidateCount ?? 0} Employee
                {(approvedCandidateCount ?? 0) > 1 ? "s" : ""}
              </div>
            </div>
            <div className="d-flex gap-3 align-items-center">
              <div className="fs-13 text-black text-nowrap">Sort By</div>
              <SortBySelect
                options={CANDIDATE_SORT_OPTIONS}
                placeholder="Select..."
                enableFilter={false}
                defaultValue={CANDIDATE_SORT_OPTIONS[0]}
                onChange={handleSorting}
                onSelect={handleSelectFilter}
              />
              <div className="form-group">
                {/* <SelectInput
                  className="form-select text-only min-h-auto fw-700"
                  options={CANDIDATE_SORT_OPTIONS}
                  onChange={handleSorting}
                  value={selectedSort}
                /> */}
                {/* <select
                  name=""
                  id=""
                  className="form-select text-only min-h-auto fw-700"
                  onChange={(e) => {
                    setSortOrder(e.target.value);
                    setCurrentApprovedPage(1); // Reset the current page to 1
                  }}
                >
                  {CANDIDATE_SORT_OPTIONS.map((option, index) => {
                    return (
                      <option
                        key={index}
                        value={option.value}
                        className="fs-16 text-black"
                      >
                        {option.label}
                      </option>
                    );
                  })}
                </select> */}
              </div>
            </div>
          </div>
          {isOpen2 && allCandidatesList && (
            <AllCandidates
              type="all_candidates"
              setSortOrder={setSelectedSort}
              setApprovedPerPage={setApprovedPerPage}
              candidatesList={allCandidatesList.candidates}
              currentApprovedPage={currentApprovedPage}
              setCurrentApprovedPage={setCurrentApprovedPage}
              getAllCandidates={getAllCandidates}
              getCandidateQualification={getCandidateQualification}
              totalList={allCandidatesList.candidates_total}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default AdminCentres;
